'use client'

import { useEffect, useState } from 'react';
import Link from 'next/link';
import { UserCircle2 } from 'lucide-react';
import { getCookie } from './lib/api-service';

export default function HomePage () {
  const [username, setUsername] = useState<null | string>(null);

  useEffect(() => {
    setUsername(getCookie("username"));
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="text-4xl font-bold mb-6">HRCore</div>
        <div>
          {username != null ? (
            <Link href="/report">
              <button className="px-6 py-2 text-white bg-slate-500 rounded-lg text-lg flex items-center justify-center mx-auto cursor-pointer">
                {username} <UserCircle2 width={20} className="ml-2" />
              </button>
            </Link>
          ) : (
            <Link href="/login">
              <button className="px-6 py-2 text-white bg-slate-500 rounded-lg text-lg mx-auto cursor-pointer">
                Нэвтрэх
              </button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};
